/* eslint-disable global-require, import/no-dynamic-require */
import _ from 'lodash';

import baseConfig from './base';

const endpoint = GLOBALS.ENDPOINTS;

let localEndpointsConfig;
if (process.env.NODE_ENV === 'development') {
  try {
    localEndpointsConfig = require(`./endpoints/${endpoint}.local`);
  } catch (error) {
    localEndpointsConfig = {};
  }
}

const endpointsConfig = require(`./endpoints/${endpoint}`);
_.merge(endpointsConfig, localEndpointsConfig);

const { hostname } = window.location;
const parts = hostname.split('.');
// If accessed using an IP address, return hostname as it is
const isIpAddress = parts.length === 4 && parts.every(part => Number.isFinite(Number(part)));
const cookieDomain = (parts.length <= 2 || isIpAddress) ? hostname : parts.slice(1).join('.');

const config = {
  cookieDomain,

  ...baseConfig,
  ...endpointsConfig,
};

export default config;
